import { ActionsUnion, getCurrentWindowId } from 'utils'
import { clientActionEvent, clientActionSubscribe } from './ClientAction'
import { EntityType } from './EntityType'
import {
  AxeEventCancel,
  AxeEventClone,
  AxeEventCreate,
  AxeEventSend,
  AxeEventStage,
  AxeEventUpdateAttributes,
  CompositeEvent,
  EntityTypeEnum,
  SubscribeType,
  SubscriptionFilter
} from './generated'
import { AxeSubscriptionIdentifier, EventSpecificArgs, SUBSCRIPTION_PAGE_SIZE } from './local'

function axePageSubscribe(subscriptionIdentifier: AxeSubscriptionIdentifier, filters: SubscriptionFilter[], pageNumber: number = 0) {
  return clientActionSubscribe({
    entityTypeEnum: EntityTypeEnum.AXE,
    preDefinedFilter: null,
    filters,
    postTransformFilters: [],
    subscribeType: SubscribeType.PAGE,
    subscriptionIdentifier,
    limitResults: false,
    pageSize: SUBSCRIPTION_PAGE_SIZE,
    pageNumber,
    summaryRequest: null
  })
}

export type AxeCreateArgs = EventSpecificArgs<AxeEventCreate>
const axeCreate = (args: AxeCreateArgs, sourceWindowId: string = getCurrentWindowId()) =>
  clientActionEvent('AxeEventCreate', args, sourceWindowId)

export type AxeCreateBulkArgs = EventSpecificArgs<CompositeEvent>
const axeCreateBulk = (args: AxeCreateBulkArgs, sourceWindowId: string = getCurrentWindowId()) =>
  clientActionEvent('CompositeEvent', args, sourceWindowId)

export type AxeCloneArgs = EventSpecificArgs<AxeEventClone>
const axeClone = (args: AxeCloneArgs, sourceWindowId: string = getCurrentWindowId()) =>
  clientActionEvent('AxeEventClone', args, sourceWindowId)

export type AxeStageArgs = EventSpecificArgs<AxeEventStage>
const axeStage = (args: AxeStageArgs, sourceWindowId: string = getCurrentWindowId()) =>
  clientActionEvent('AxeEventStage', args, sourceWindowId)

export type AxeSendArgs = EventSpecificArgs<AxeEventSend>
const axeSend = (args: AxeSendArgs, sourceWindowId: string = getCurrentWindowId()) =>
  clientActionEvent('AxeEventSend', args, sourceWindowId)

export type AxeCancelArgs = EventSpecificArgs<AxeEventCancel>
const axeCancel = (args: AxeCancelArgs, sourceWindowId: string = getCurrentWindowId()) =>
  clientActionEvent('AxeEventCancel', args, sourceWindowId)

export type AxeUpdateAttributesArgs = EventSpecificArgs<AxeEventUpdateAttributes>
const axeUpdateAttributes = (args: AxeUpdateAttributesArgs, sourceWindowId: string = getCurrentWindowId(), correlationId?: string) =>
  clientActionEvent(
    'AxeEventUpdateAttributes',
    args,
    sourceWindowId,
    {
      entityIds: [args.axeId],
      entityType: EntityType.AXE
    },
    undefined,
    correlationId
  )

export const AxeActions = {
  create: axeCreate,
  createBulk: axeCreateBulk,
  clone: axeClone,
  stage: axeStage,
  send: axeSend,
  cancel: axeCancel,
  updateAttributes: axeUpdateAttributes,
  pageSubscribe: axePageSubscribe
}

export type AxeActions = ActionsUnion<typeof AxeActions>
